import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationType } from "@duosoftbg/nacid-components";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/seAdditionalDocForm";

const SeAdditionalDocStepDocuments = () => {
  const seAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.SeAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    seAdditionalDocForm,
    baseEndpointPaths.seAdditionalDoc,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset("SECONDARY_ADDITIONAL_DOCUMENTS", seAdditionalDocForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={seAdditionalDocForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.seServices.applications.info"]}
      applicationType={ApplicationType.SE_RECOGNITION}
      applicationSubType={"SECONDARY_ADDITIONAL_DOCUMENTS"}
    />
  );
};
export default SeAdditionalDocStepDocuments;
